import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CityService, UtilityService } from 'services';
import { take } from 'rxjs/operators';
import { FieldConfig } from 'models/field.interface';
import { GfcService } from 'adminModules/gfc/gfc.service';
import { S } from '@angular/cdk/keycodes';

@Component({
  templateUrl: './attach-file.component.html',
  styles: ['.hint{font-size:0.8rem; opacity:0.7}']
})
export class AttachFileComponent implements OnInit {

  field: FieldConfig;
  group: FormGroup;
  control: FormControl;
  fileTypes;

  constructor(private city: CityService, 
    private util: UtilityService,
    private gfc: GfcService
   ) { }

  ngOnInit() {
    console.log("File Type :::",this.field, this.group, this.control);
    this.fileTypes = this.field?.fileType?.reduce((acc, value) => acc + `${value},`, '');
  }

  onSelectedFile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      
      // Validate file type
      const allowedExtensions = this.field?.fileType;
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      if (allowedExtensions.toString() != "attachment" && !allowedExtensions.includes(fileExtension || '')) {
          let data: string[] = [allowedExtensions.toString()];
          let cleanedData: string[] = data.map(item => item.replace(/[\[\]]/g, ""));        
          const msg = `Only ${cleanedData.join(", ")} files are allowed!`;
          event.target.value = '';
          this.remove();
          this.util.showMsg(msg, 'Error');
          return;
      }

      const formData = new FormData();
      formData.append('file', file);
      this.city.uploadPhoto(formData, 'cityprofile').subscribe(
        res => {
          if (res.data) {
            this.group.get(this.field.name).setValue(res.data);
          } else {
            this.util.showMsg('Something went Wrong', 'Error');
          }
        }, err => { this.util.errorMessage(err); }
      );
    } else {
      this.group.get(this.field.name).setValue(null);
    }
  }
  isRequired() {
    return this.util.isRequired(this.group.get(this.field.name));
  }
  removeFile() {
    this.util.confirm(`Remove?`, `Are you sure want to remove this file?`)
      .pipe(take(1)).subscribe(confirmed => {
        if (confirmed) { this.remove(); }
      });
  }
  remove() {
    if (this.group.get(this.field.name).value) {
      this.group.get(this.field.name).setValue(null);
    }
  }
  getFile() {
    // Get mediaUrl by mediaId.
    if (this.group.get(this.field.name).value) {
      const file =this.group.get(this.field.name).value?.media;
      if (!file) {
        return this.util.showError("File Not Found");
      } else {
          this.gfc.getuploadImageByFolder(file).subscribe((res) => {
            // console.log("singleFile",res)
            this.downloadSingleFile(res.data, "");
          });
       
      }
    }
  }
  
  /// added this
  downloadSingleFile(fileName, content) {
    const blob = new Blob([fileName], { type: "application/images" });
    const url = fileName;
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.target = "_blank";
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  
}
